import type {Theme} from '@/types';

export const amoled: Theme = {
    name: 'amoled',
    colours: {
        background: '#000000',
        backgroundDark: '#101010',
        backgroundDarker: '#000000',
        backgroundDarkest: '#0c0c0c',
        backgroundLight: '#000000',
        backgroundLighter: '#000000',
        backgroundLightest: '#3a3a3a',
        backgroundGradient: 'linear-gradient(200deg,#000000 0%,#000000 100%)',
        backgroundMediumLight: '#000000',
        backgroundObservations: 'linear-gradient(180deg, #000000 0%, #000000 100%)',
        backgroundSettingsItem: '#181818',
        selectedLight: '#181818',
    },
    invertRadar: true,
};
